export default __webpack_public_path__ + "static/media/expert-bg.d0340a1f.svg";